import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";

const ThreeDotMenu = ({ onEdit, onDelete, hideEdit }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEdit && onEdit();
    handleClose();
  };

  const handleDelete = () => {
    onDelete && onDelete();
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleMenuClick} sx={{ padding: "0px" }}>
        <MoreVertIcon style={{ color: "#4CAF50" }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{ top: "0px", left: "-30px", border: "1px solid", padding: "0px" }}
      >
        {!hideEdit && (
          <MenuItem onClick={handleEdit}>
            <EditIcon style={{ fill: "#4CAF50", fontSize: "20px" }} />
            <Typography sx={{ fontSize: "12px" }}>{t("Edit")}</Typography>
          </MenuItem>
        )}
        <MenuItem onClick={handleDelete}>
          <DeleteIcon style={{ fill: "#CF5C5C", fontSize: "20px" }} />
          <Typography sx={{ fontSize: "12px" }}>{t("Delete")}</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ThreeDotMenu;
